import {Component} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";

let source = axios.CancelToken.source();

class Dashboard5 extends Component {
    constructor() {
        super();
        this.state = {
            objs: [],
            objsl: false,
            txtkm: 200,
            to_sites: [],
            to_dds: [],

        }
    }

    tabletodd = () => {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.objs.to_dds.map(value => {
                let isarrived = value.isarrived == 1 ? "Yes" : "No";
                return (<tr>
                    <th>{value.plate_no}</th>
                    <td>{value.frightno}</td>
                    <td>{value.to}</td>
                    <td>{value.from}</td>
                    <td>{isarrived}</td>
                    <td>{value.status}</td>
                    <td>{value.km}</td>
                    <td>{value.eta}</td>
                    <td>{value.loc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofarivalatloadpoint}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tabletosite = () => {
        let retdata = null;
        if (this.state.objsl) {
            retdata = this.state.to_sites.map(value => {
                let isarrived = value.isarrived == 1 ? "Yes" : "No";
                return (<tr>
                    <th>{value.plate_no}</th>
                    <td>{value.frightno}</td>
                    <td>{value.to}</td>
                    <td>{value.from}</td>
                    <td>{isarrived}</td>
                    <td>{value.status}</td>
                    <td>{value.km}</td>
                    <td>{value.eta}</td>
                    <td>{value.loc}</td>
                    <td>{value.avltime}</td>
                    <td>{value.dateofallocation}</td>
                    <td>{value.dateofarivalatloadpoint}</td>
                    <td>{value.dateofloading}</td>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.dateofarivalatoffloadpoint}</td>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                </tr>)
            })
        }
        return <>{retdata}</>
    }
    tabletoyesterday = () => {
        let retdata = null;
        let retdata2 = null;
        if (this.state.objsl) {
            let count = 0;
            let count2 = 0;
            retdata = this.state.objs.yesterd_unload_dd.map(value => {
                count = count + 1;
                return (<tr>
                    <th>{count}</th>
                    <th>{value.plate_no}</th>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>Unloading</td>
                </tr>)
            })
            retdata2 = this.state.objs.yesterd_unload_site.map(value => {
                count2 = count2 + 1;
                return (<tr>
                    <th>{count2}</th>
                    <th>{value.plate_no}</th>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>Loading</td>
                </tr>)
            })
        }
        return <>{retdata}{retdata2}</>
    }
    tabletotoday= () => {
        let retdata = null;
        let retdata2 = null;
        if (this.state.objsl) {
            let count = 0;
            let count2 = 0;
            retdata = this.state.objs.today_unload_dd.map(value => {
                count = count + 1;
                return (<tr>
                    <th>{count}</th>
                    <th>{value.plate_no}</th>
                    <td>{value.dateofoffloading}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>Unloading</td>
                </tr>)
            })
            retdata2 = this.state.objs.today_unload_site.map(value => {
                count2 = count2 + 1;
                return (<tr>
                    <th>{count2}</th>
                    <th>{value.plate_no}</th>
                    <td>{value.dateofdeparture}</td>
                    <td>{value.org}</td>
                    <td>{value.des}</td>
                    <td>Loading</td>
                </tr>)
            })
        }
        return <>{retdata}{retdata2}</>
    }
    tablesummury = () => {
        let retdata = null;
        if (this.state.objsl) {
            let count = 0;
            let count2 = 0;
            let to_site_dawro = this.state.objs.yesterd_unload_site.filter(value => {
                if (value.org == "DAWR")
                    return value;
            }).length;
            let to_site_koka = this.state.objs.yesterd_unload_site.filter(value => {
                if (value.org == "KOK")
                    return value;
            }).length;
            let to_site_dili = this.state.objs.yesterd_unload_site.filter(value => {
                if (value.org == "DILI")
                    return value;
            }).length;
            let to_site_arjo = this.state.objs.yesterd_unload_site.filter(value => {
                if (value.org == "ARJO")
                    return value;
            }).length;
            let to_site_total = to_site_dawro + to_site_koka + to_site_dili + to_site_arjo;

            let to_dd_dawro = this.state.objs.yesterd_unload_dd.filter(value => {
                if (value.org == "DAWR")
                    return value;
            }).length;
            let to_dd_koka = this.state.objs.yesterd_unload_dd.filter(value => {
                if (value.org == "KOK")
                    return value;
            }).length;
            let to_dd_dili = this.state.objs.yesterd_unload_dd.filter(value => {
                if (value.org == "DILI")
                    return value;
            }).length;
            let to_dd_arjo = this.state.objs.yesterd_unload_dd.filter(value => {
                if (value.org == "ARJO")
                    return value;
            }).length;
            let to_dd_total = to_dd_dawro + to_dd_koka + to_dd_dili + to_dd_arjo;

            let to_site_dawro_today = this.state.to_sites.filter(value => {
                if (value.eta == "TODAY" && value.org == "DAWR")
                    return value;
            }).length;
            let to_site_koka_today = this.state.to_sites.filter(value => {
                if (value.eta == "TODAY" && value.org == "KOK")
                    return value;
            }).length;
            let to_site_dili_today = this.state.to_sites.filter(value => {
                if (value.eta == "TODAY" && value.org == "DILI")
                    return value;
            }).length;
            let to_site_arjo_today = this.state.to_sites.filter(value => {
                if (value.eta == "TODAY" && value.org == "ARJO")
                    return value;
            }).length;
            let to_site_total_today = to_site_dawro_today + to_site_koka_today + to_site_dili_today + to_site_arjo_today;

            let to_dd_dawro_today = this.state.to_dds.filter(value => {
                if (value.eta == "TODAY" && value.org == "DAWR")
                    return value;
            }).length;
            let to_dd_koka_today = this.state.to_dds.filter(value => {
                if (value.eta == "TODAY" && value.org == "KOK")
                    return value;
            }).length;
            let to_dd_dili_today = this.state.to_dds.filter(value => {
                if (value.eta == "TODAY" && value.org == "DILI")
                    return value;
            }).length;
            let to_dd_arjo_today = this.state.to_dds.filter(value => {
                if (value.eta == "TODAY" && value.org == "ARJO")
                    return value;
            }).length;
            let to_dd_total_today = to_dd_dawro_today + to_dd_koka_today + to_dd_dili_today + to_dd_arjo_today;

            return (<>
                <div className="px-3 py-1 text-left"><a href="#" onClick={this.btnexport_Summary}>.xlsx</a></div>
                <table id="Summary" className="table table-head-fixed text-nowrap">
                    <thead>
                    <tr>
                        <th>COAL TRUCK STATUS</th>
                        <th>DAWRO</th>
                        <th>KOKA</th>
                        <th>DELIB</th>
                        <th>ARJO</th>
                        <th>TOTAL</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>DAILY PLAN DISPATCH OF COAL FROM SITE</th>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>15</td>
                    </tr>
                    <tr>
                        <th>DAILY ACTUAL DISPATCH OF COAL FROM SITE</th>
                        <td>{to_site_dawro}</td>
                        <td>{to_site_koka}</td>
                        <td>{to_site_dili}</td>
                        <td>{to_site_arjo}</td>
                        <td>{to_site_total}</td>
                    </tr>
                    <tr>
                        <th>DAILY PLAN DELIVERY OF COAL TO DD</th>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>15</td>
                    </tr>
                    <tr>
                        <th>DAILY ACTUAL DELIVERED OF COAL AT DD</th>
                        <td>{to_dd_dawro}</td>
                        <td>{to_dd_koka}</td>
                        <td>{to_dd_dili}</td>
                        <td>{to_dd_arjo}</td>
                        <td>{to_dd_total}</td>
                    </tr>
                    <tr>
                        <th>PLAN TO DATE DELIVER OF COAL TO DD</th>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                    </tr>
                    <tr>
                        <th>ACTUAL TO DATE COAL DELIVERED TO DD</th>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                    </tr>
                    <tr>
                        <th>(Today) DAILY PLAN DISPATCH OF COAL FROM SITE</th>
                        <td>{to_site_dawro_today}</td>
                        <td>{to_site_koka_today}</td>
                        <td>{to_site_dili_today}</td>
                        <td>{to_site_arjo_today}</td>
                        <td>{to_site_total_today}</td>
                    </tr>
                    <tr>
                        <th>(Today) DAILY PLAN DELIVERY OF COAL TO DD</th>
                        <td>{to_dd_dawro_today}</td>
                        <td>{to_dd_koka_today}</td>
                        <td>{to_dd_dili_today}</td>
                        <td>{to_dd_arjo_today}</td>
                        <td>{to_dd_total_today}</td>
                    </tr>
                    </tbody>
                </table>
            </>)
        }
        return <>{retdata}</>
    }

    componentDidMount() {
        this.fetcheddata()
    }

    fetcheddata = () => {
        let baseurl = myconfig.dashboard_5;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            objs: [],
            objsl: false,
            to_sites: [],
            to_dds: [],
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs: res.data,
                    to_sites: res.data.to_sites,
                    to_dds: res.data.to_dds,
                    objsl: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }

    btnexport_Summary= (event) => {
        event.preventDefault();
        let wb = XLSX.utils.book_new();
        wb.SheetNames.push("Summary");
        let wb2 = XLSX.utils.table_to_sheet(document.getElementById('Summary'));
        wb.Sheets["Summary"] = wb2;
        XLSX.writeFile(wb, "Summary.xlsx");
    }
    btnexport_To_dire_dawa= (event) => {
        event.preventDefault();
        let wb = XLSX.utils.book_new();
        wb.SheetNames.push("To_dire_dawa");
        let wb2 = XLSX.utils.table_to_sheet(document.getElementById('To_dire_dawa'));
        wb.Sheets["To_dire_dawa"] = wb2;
        XLSX.writeFile(wb, "To_dire_dawa.xlsx");
    }
    btnexport_To_site= (event) => {
        event.preventDefault();
        let wb = XLSX.utils.book_new();
        wb.SheetNames.push("To_site");
        let wb2 = XLSX.utils.table_to_sheet(document.getElementById('To_site'));
        wb.Sheets["To_site"] = wb2;
        XLSX.writeFile(wb, "To_site.xlsx");
    }
    btnexport_Yesterday= (event) => {
        event.preventDefault();
        let wb = XLSX.utils.book_new();
        wb.SheetNames.push("Yesterday");
        let wb2 = XLSX.utils.table_to_sheet(document.getElementById('Yesterday'));
        wb.Sheets["Yesterday"] = wb2;
        XLSX.writeFile(wb, "Yesterday.xlsx");
    }
    btnexport_Today= (event) => {
        event.preventDefault();
        let wb = XLSX.utils.book_new();
        wb.SheetNames.push("Today");
        let wb2 = XLSX.utils.table_to_sheet(document.getElementById('Today'));
        wb.Sheets["Today"] = wb2;
        XLSX.writeFile(wb, "Today.xlsx");
    }

    inputmgt_fitler = (event) => {
        event.preventDefault();
        if (this.state.objsl) {
            var name = event.target.name;
            var value = event.target.value;
            this.setState({
                [name]: value,
            })
            let temp = this.state.objs.to_dds;
            let temp2 = this.state.objs.to_sites;
            if (value != "" && !isNaN(value)) {
                temp = temp.map(v => {
                    if (v.km <= value)
                        v.eta = "TODAY";
                    else
                        v.eta = "TOMORROW";
                    return v;
                })
                temp2 = temp2.map(v => {
                    if (v.km <= value)
                        v.eta = "TODAY";
                    else
                        v.eta = "TOMORROW";
                    return v;
                })
            } else {
                temp = temp.map(v => {
                    v.eta = "";
                    return v;
                })
            }
            this.setState({
                to_dds: temp,
                to_sites: temp2,
            })
        }
    }

    render() {
        return (
            <>
                <Nav type="dashboard5"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Dashboard-5</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                                        <li className="breadcrumb-item active">Dashboard-5</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-md-10">
                                    <div className="card card-cyan">
                                        <div className="card-header">
                                            <div className="card-tools">
                                                <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                    <input type="text" name="txtkm" value={this.state.txtkm}
                                                           onChange={this.inputmgt_fitler}
                                                           className="form-control float-right" placeholder="KM"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-header">
                                            <h3 className="card-title">Summery Report</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            {this.tablesummury()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">To Dire Dawa</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="px-3 py-1 text-left"><a href="#" onClick={this.btnexport_To_dire_dawa}>.xlsx</a></div>
                                            <table id="To_dire_dawa" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>Truck</th>
                                                    <th>FO</th>
                                                    <th>To</th>
                                                    <th>From</th>
                                                    <th>Is Arrived</th>
                                                    <th>Status</th>
                                                    <th>Km</th>
                                                    <th>ETA</th>
                                                    <th>Location</th>
                                                    <th>AVL Time</th>
                                                    <th>Allocation</th>
                                                    <th>Arrival @ Load</th>
                                                    <th>Loading</th>
                                                    <th>Departure</th>
                                                    <th>Arrival @ Offload</th>
                                                    <th>Unloading</th>
                                                    <th>Org</th>
                                                    <th>Des</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabletodd()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="card card-fuchsia">
                                        <div className="card-header">
                                            <h3 className="card-title">To Site</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="px-3 py-1 text-left"><a href="#" onClick={this.btnexport_To_site}>.xlsx</a></div>
                                            <table id="To_site" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>Truck</th>
                                                    <th>FO</th>
                                                    <th>To</th>
                                                    <th>From</th>
                                                    <th>Is Arrived</th>
                                                    <th>Status</th>
                                                    <th>Km</th>
                                                    <th>ETA</th>
                                                    <th>Location</th>
                                                    <th>AVL Time</th>
                                                    <th>Allocation</th>
                                                    <th>Arrival @ Load</th>
                                                    <th>Loading</th>
                                                    <th>Departure</th>
                                                    <th>Arrival @ Offload</th>
                                                    <th>Unloading</th>
                                                    <th>Org</th>
                                                    <th>Des</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabletosite()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card card-cyan">
                                        <div className="card-header">
                                            <h3 className="card-title">Yesterday Load & Unload</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="px-3 py-1 text-left"><a href="#" onClick={this.btnexport_Yesterday}>.xlsx</a></div>
                                            <table id="Yesterday" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>Date</th>
                                                    <th>Org</th>
                                                    <th>Destination</th>
                                                    <th>Unload/Load</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabletoyesterday()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="card card-green">
                                        <div className="card-header">
                                            <h3 className="card-title">Today Load & Unload</h3>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{height: '300px'}}>
                                            <div className="px-3 py-1 text-left"><a href="#" onClick={this.btnexport_Today}>.xlsx</a></div>
                                            <table id="Today" className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Truck</th>
                                                    <th>Date</th>
                                                    <th>Org</th>
                                                    <th>Destination</th>
                                                    <th>Unload/Load</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.tabletotoday()}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}
export default Dashboard5;
